import React, { useState, useEffect } from 'react';
import { Phone, X, Wrench } from 'lucide-react';

const OrderingDisabledModal = ({ isOpen, onClose, trigger = 'auto' }) => {
  if (!isOpen) return null;

  const handleCallNow = () => {
    window.location.href = 'tel:+36309517159';
  };

  return (
    <>
      {/* Backdrop with blur */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div 
          className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 animate-fadeIn"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>

          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-[#FFA726] to-[#FF9800] rounded-full flex items-center justify-center shadow-lg">
              <Wrench className="w-10 h-10 text-white" />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-black text-gray-900 text-center mb-4">
            Online rendelés jelenleg nem elérhető
          </h2>

          {/* Message */}
          <div className="text-center space-y-4 mb-8">
            <p className="text-gray-700 leading-relaxed text-lg">
              Rendeléshez kérjük, hívjon minket telefonon!
            </p>
            <p className="text-lg font-semibold text-[#00BCD4]">
              📞 Hívj minket és azonnal felvesszük a rendelésed!
            </p>
          </div>

          {/* Buttons */}
          <div className="space-y-3">
            {/* Primary CTA - Call Now */}
            <button
              onClick={handleCallNow}
              className="w-full flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-[#FFA726] to-[#FF9800] text-white rounded-xl font-bold text-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              <Phone className="w-5 h-5" />
              <span>📞 Hívás most</span>
            </button>

            {/* Secondary - Close */}
            <button
              onClick={onClose}
              className="w-full px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
            >
              Rendben
            </button>
          </div>

          {/* Phone number display */}
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500 mb-1">Telefonszám:</p>
            <a 
              href="tel:+36309517159"
              className="text-xl font-bold text-[#00BCD4] hover:underline"
            >
              +36 30 951 7159
            </a>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default OrderingDisabledModal;
